import { doc, getDoc, setDoc, onSnapshot } from 'firebase/firestore';
import { db } from './config';

export interface ApiKeys {
  openai: string;
  elevenlabs: string;
}

export const saveApiKeys = async (userId: string, keys: ApiKeys): Promise<void> => {
  try {
    const docRef = doc(db, `users/${userId}/settings/api`);
    await setDoc(docRef, keys, { merge: true });
  } catch (error) {
    console.error('Error saving API keys:', error);
    throw new Error('Failed to save API keys');
  }
};

export const loadApiKeys = async (userId: string): Promise<ApiKeys | null> => {
  try {
    const docRef = doc(db, `users/${userId}/settings/api`);
    const docSnap = await getDoc(docRef);
    return docSnap.exists() ? (docSnap.data() as ApiKeys) : null;
  } catch (error) {
    console.error('Error loading API keys:', error);
    throw new Error('Failed to load API keys');
  }
};

export const subscribeToApiKeys = (
  userId: string,
  onKeysUpdate: (keys: ApiKeys | null) => void,
  onError: (error: Error) => void
): (() => void) => {
  const docRef = doc(db, `users/${userId}/settings/api`);
  
  return onSnapshot(
    docRef,
    (snapshot) => {
      if (snapshot.exists()) {
        onKeysUpdate(snapshot.data() as ApiKeys);
      }
    },
    (error) => {
      console.error('Error in API keys subscription:', error);
      onError(new Error('Failed to sync API keys'));
    }
  );
};